import { InstallmentPaymentMethod } from '../../types/InstallmentPaymentMethod';
import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';

export const sortPaymentMethodsByRank = (
  paymentMethods: BuyNowPayLaterMethod[]
): InstallmentPaymentMethod[] | PaymentMethod[] => {
  return paymentMethods
    .sort((aMethod, bMethod) => aMethod.rank - bMethod.rank)
    .map((pm) => pm.paymentMethod as InstallmentPaymentMethod & PaymentMethod);
};
